import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "src/design-system/tokens";
import icons from "src/design-system/icons";
import GrSearch from "src/design-system/components/GrSearch";
import GrButton from "src/design-system/components/GrButton";
import GrCard from "src/design-system/components/GrCard";
import GrEmptyState from "src/design-system/components/GrEmptyState";
import GrIcon from "src/design-system/components/GrIcon";

/**
 * Search box (in the page header, opposite the title), "no match" card and Load more for the
 * programme lists (Programmes, Videos Library). `search` is what useProgrammeSearch returns.
 */

export function ProgrammeSearchBar({ search }) {
  return (
    <GrSearch
      value={search.query}
      onChange={(e) => search.setQuery(e.target.value)}
      onClear={() => search.setQuery("")}
      placeholder="Search programmes"
      label="Search programmes"
      aria-busy={search.isSearching || undefined}
      sx={{ width: { xs: "100%", sm: 320 } }}
    />
  );
}

export function ProgrammeNoMatch({ search }) {
  return (
    <GrCard>
      <GrEmptyState
        icon={<GrIcon icon={icons.search} />}
        title="No programmes match"
        text={`Nothing found for “${search.query.trim()}”. Try another name.`}
        action={
          <GrButton variant="secondary" size="sm" onClick={() => search.setQuery("")}>
            Clear search
          </GrButton>
        }
      />
    </GrCard>
  );
}

export function ProgrammeLoadMore({ search }) {
  if (!search.hasMore) return null;
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: gr.space[6] }}>
      <GrButton variant="secondary" loading={search.loadingMore} onClick={search.loadMore}>
        Load more
      </GrButton>
    </Box>
  );
}

const searchShape = PropTypes.shape({
  query: PropTypes.string,
  setQuery: PropTypes.func,
  hasMore: PropTypes.bool,
  loadingMore: PropTypes.bool,
  isSearching: PropTypes.bool,
  loadMore: PropTypes.func,
}).isRequired;
ProgrammeSearchBar.propTypes = { search: searchShape };
ProgrammeNoMatch.propTypes = { search: searchShape };
ProgrammeLoadMore.propTypes = { search: searchShape };
